import { CopiedGrid } from '../../../../orderState.types';
import { OrderProductGridItem } from '../../../orderProducts.types';
import { OrderProductForGridContainer } from '../../grid/components/orderProductGrid/components/grid/types/orderProductGridContainer.types';

export enum CopyOrPasteStatusEnum {
  ON_PASTED_GRID = 'ON_PASTED_GRID',
  ON_PASTE_ACTION = 'ON_PASTE_ACTION',
  ON_COPY_ACTION = 'ON_COPY_ACTION',
  ON_UNABLE_TO_PASTE = 'ON_UNABLE_TO_PASTE',
  ON_COPY_SELECTED = 'ON_COPY_SELECTED',
}

export interface GetCopyOrPasteButtonStatusParams {
  copiedGrid: CopiedGrid;
  product: OrderProductForGridContainer;
  grid: OrderProductGridItem[];
  orderId?: string;
  isPasted?: boolean;
}
